module.exports = __webpack_public_path__ + "media/images/instagram-0859eccaaad4aa71641d2fe384adf70d.svg";